import React from 'react'

import { AboutContainer, TextContainer } from './styles'

const Banner = () => {
  return (
    <AboutContainer>
      <TextContainer>
        <h1>Acerca de EQUIP</h1>
        <p>
          Somos una startup Peruana que está revolucionando la manera en que las constructoras
          adquieren materiales de construcción. A través de nuestra plataforma 100% digital y con el
          uso de inteligencia artificial, optimizamos el proceso de cotización, ofreciendo precios
          competitivos y agilizando cada etapa de compra.
        </p>
      </TextContainer>
    </AboutContainer>
  )
}

export default Banner
